/**
 * Identifies this app to Iterable on every embedded-messaging call (`packageName` query param on
 * the fetch, and `deviceInfo.appPackageName` on every tracked event).
 *
 * On web this is a value *we* choose — Iterable's docs call it "the package name you use to
 * identify your website", unlike iOS/Android where it is the real bundle id. Nothing in Iterable
 * issues or validates it, and a placement carries no package name of its own.
 *
 * What it must be is **stable**. Every impression, click and dismissal is filed under it, so
 * changing it later splits this app's embedded-messaging history in two, with no way to stitch
 * the halves back together. It also has to match whatever the patient and admin apps do *not*
 * use, so the three stay separable in Snowflake.
 */
export const APP_PACKAGE_NAME = 'quickmd-provider'

/**
 * How often we re-fetch embedded messages.
 *
 * Iterable's *mobile* SDKs poll on their own; the web SDK does not — `syncMessages` is a one-shot
 * GET — so the cadence is ours to own. Ten minutes matches what the ticket promises ("appears
 * within one polling cycle") and what the mobile SDKs do, which keeps the two platforms honest
 * about the same campaign.
 */
export const POLL_INTERVAL_MS = 10 * 60 * 1000

/**
 * The custom action a message's button uses to dismiss itself.
 *
 * Announcements have no close affordance of their own — the design's single "Got it" button *is*
 * the dismissal (confirmed against the Iterable POC). Whoever publishes the campaign writes the
 * label; this id is what makes the button dismiss rather than navigate.
 */
export const DISMISS_ACTION_ID = 'dismiss'
